import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import {
  Table,
  Avatar,
  Row,
  Col,
  message,
  Checkbox,
  Tag,
  Tabs,
  Modal,
  Form,
  Input,
  Button,
  Popconfirm,
} from 'antd'
import util from '../../util/util'
import '../../css/fulfillment.scss'
import { FullfillmentRowSelect } from '../../store/action/callback.action'
import { constants } from '../../constants'
import {
  getFullfillmentViewDevices,
  updateTrackingLink,
  updateGatewayId,
  markAsDeleted,
} from '../../store/action/device.action'
import atrchivesvg from '../../images/archive.svg'
const { ROLE } = constants
const { TextArea } = Input
const FullfillmentViewTable = (props) => {
  var history = useHistory()
  const params = useParams()
  const [note, setNote] = useState('')
  const [tracking, setTracking] = useState({
    open: false,
    link: '',
    deviceid: '',
  })
  const [gateway, setGateway] = useState({
    open: false,
    gatewayid: '',
    deviceid: '',
  })
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [errorDetail, setErrorDetail] = useState({})
  const [form] = Form.useForm()
  const fulfillmentid = params.fulfillmentid

  const [openNote, setOpenNote] = useState(false)
  const fetchFullfillments = () => {
    props.getFullfillmentViewDevices(fulfillmentid)
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e.deviceid))
    return data
  }

  var dataSource = formatdata(props.fullfillmentDevices?.devices)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  const submitNote = (values) => {
    console.log(form.getFieldsValue())
  }
  var renderDeviceName = (device, obj) => {
    return (
      <Row className={'nameRow'}>
        <span>{device?.name ? _.upperFirst(device.name) : 'NA'}</span>
      </Row>
    )
  }
  var renderShippingAddress = (device, obj) => {
    let addressStr = ''
    if (device.fulfillment_request) {
      // console.log('device.fulfillment_request', device)
      let {
        shipping_address,
        shipping_city,
        shipping_state,
        shipping_zip_code,
        country,
      } = device.fulfillment_request
      let address = {
        shipping_address,
        shipping_city,
        shipping_state,
        shipping_zip_code,
        country,
      }
      Object.keys(address).map((k) => {
        if (address[k] && address[k] != '') addressStr += address[k] + '\n'
      })
    }
    return (
      <Row className={'nameRow'}>
        <span>
          {device.fulfillment_request && addressStr != ''
            ? _.upperFirst(addressStr)
            : 'NA'}
        </span>
      </Row>
    )
  }
  var renderGatewayId = (device, obj) => {
    return (
      <Row className={'nameRow'}>
        {device?.hardware_uuid ? device.hardware_uuid : 'NA'}
      </Row>
    )
  }

  var renderTracPatchFields = (obj) => {
    const { white_short, blue_short, leg_side } = obj
    return (
      <Row className={'nameRow'} style={{ flexDirection: 'column', gap: 2 }}>
        <span>WHITE: {white_short || '—'}</span>
        <span>BLUE: {blue_short || '—'}</span>
        <span>Leg: {leg_side ? _.upperFirst(leg_side) : '—'}</span>
      </Row>
    )
  }
  var renderTrackingLink = (device, obj) => {
    const { shipping_tracking_link } = device.fulfillment_request
    return (
      <Row className={'nameRow'}>
        <span
          className='link'
          onClick={() =>
            setTracking({
              open: false,
              link: shipping_tracking_link ? shipping_tracking_link : '',
              deviceid: obj.deviceid,
            })
          }
        >
          {shipping_tracking_link ? shipping_tracking_link : 'NA'}
        </span>
      </Row>
    )
  }
  var renderDeviceStatus = (status, obj) => {
    return (
      <Row className={'nameRow'}>
        <Col>{status ? status : 'NA'}</Col>
        {status == 'fail' && (
          <Col
            className='view-detail link'
            onClick={() => handleViewDetail(obj)}
          >
            View Details
          </Col>
        )}
      </Row>
    )
  }

  const handleDelete = async(deviceid) =>{
    try{
    const res =  await props.markAsDeleted({_id:fulfillmentid,deviceid});
    if(res) await props.getFullfillmentViewDevices(fulfillmentid)
    }
    catch(err){
      console.log(err,"Error in handleDelete")
    }
  }
    var updateStatus = (deviceid, obj) => {
       const isActive = props.activeDevices?.some((d) => d.deviceid == deviceid);
    return (
      <>
      {(!isActive && obj.status!='Deleted' && obj.status !='Shipped' ) &&
        <Popconfirm
          title='Are you sure？'
          okText='Yes'
          cancelText='No'
          onConfirm={(e) => {
            e.stopPropagation()
            e.nativeEvent.stopImmediatePropagation()
            handleDelete(deviceid)
          }}
        >
          <img
            // id={'messageaction'}
            onClick={(e) => e.stopPropagation()}
            width='26px'
            src={atrchivesvg}
          />
        </Popconfirm> 
      }
      </>
    )
  }
  const handleNote = (note) => {
    setNote(note)
    setOpenNote(true)
  }
  var renderNote = (note, obj) => {
    return (
      <Row className={'nameRow'}>
        <span>
          {note ? note : <span onClick={() => handleNote(note)}>Add Note</span>}
        </span>
      </Row>
    )
  }
  var handleRowClick = (record) =>
    history.push({ pathname: `/fulfillment/${record._id}` })
  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }
  const handleViewDetail = (obj) => {
    setErrorDetail(obj)
    setIsModalVisible(true)
  }
  const formatMetaData = (metaDataString) => {
    try {
      const metaData = JSON.parse(metaDataString)

      return (
        <div>
          {Object.entries(metaData).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '10px' }}>
              <strong>{key}:</strong>
              {typeof value === 'object' && !Array.isArray(value) ? (
                // Recursively format nested objects
                formatMetaData(JSON.stringify(value))
              ) : (
                <ul>
                  {Array.isArray(value) ? (
                    value.map((item, index) => <li key={index}>{item}</li>)
                  ) : (
                    <li>{value}</li>
                  )}
                </ul>
              )}
            </div>
          ))}
        </div>
      )
    } catch (error) {
      console.log(error, 'Error in handleViewDetail')
    }
  }
  const renderMetaDataModal = () => {
    return (
      <Modal
        title={<div style={{ textAlign: 'center' }}>View Details</div>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
      >
        <div>
          <Row>
            <Col span={7} className='view-detail-title'>
              Status Description :
            </Col>
            <Col className='status-description'>
              {errorDetail.statusDescription
                ? errorDetail.statusDescription
                : 'NA'}
            </Col>
          </Row>
          <Row>
            {/* <Col  span={24}  className='view-detail-title'>Meta Data </Col> */}
            <Col>
              {errorDetail.meta_data
                ? formatMetaData(errorDetail.meta_data)
                : 'NA'}
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
  const submitTrackingLink = async () => {
    const data = {
      _id: fulfillmentid,
      tracking_link: tracking.link,
      deviceid: tracking.deviceid,
    }
    const status = await props.updateTrackingLink(data)
    if (status) {
      await props.getFullfillmentViewDevices(fulfillmentid)
      setTracking({ ...tracking, open: false })
    }
  }
  const handleSubmitGateway = async () => {
    const data = {
      _id: fulfillmentid,
      gateway_id: gateway.gatewayid,
      deviceid: gateway.deviceid,
    }
    const status = await props.updateGatewayId(data)
    if (status) {
      await props.getFullfillmentViewDevices(fulfillmentid)
      setGateway({ ...gateway, open: false })
    }
  }
  const submitGatewayId = async () => {
    Modal.confirm({
      title: 'Are you sure you want to update the Gateway ID?',
      content: 'Once the gateway updated, the older devices wont work.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmitGateway(),
      onCancel: () => setGateway({ ...gateway, open: false }),
    })
  }
  const renderNoteModal = () => {
    return (
      <Modal
        visible={openNote}
        footer={false}
        onCancel={() => setOpenNote(false)}
        centered
        width={300}
      >
        <Form
          form={form}
          layout='vertical'
          onFinish={submitNote}
          initialValues={{
            note: note,
          }}
        >
          <Form.Item
            label='Description'
            name='note'
            rules={[{ required: true, message: 'Please enter a description!' }]}
          >
            <TextArea rows={4} placeholder='Enter your description here' />
          </Form.Item>

          <Form.Item>
            <Button type='primary' htmlType='submit'>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const renderTracklinLinkModal = () => {
    return (
      <Modal
        title='Update Tracking Link'
        visible={tracking.open}
        footer={false}
        onCancel={() => setTracking({ link: '', open: false })}
        centered
        width={400}
        bodyStyle={{
          padding: '30px',
          textAlign: 'center',
        }}
      >
        <Row justify='space-around'>
          <Col span={15}>
            <Input
              value={tracking.link || ''}
              onChange={(e) =>
                setTracking({ ...tracking, link: e.target.value })
              }
              placeholder='Enter tracking link'
            />
          </Col>
          <Col span={9}>
            <Button type='primary' onClick={submitTrackingLink}>
              Save
            </Button>
          </Col>
        </Row>
      </Modal>
    )
  }
  const renderGatewayIdModal = () => {
    return (
      <Modal
        title='Update Gateway Id'
        visible={gateway.open}
        footer={false}
        onCancel={() => setGateway({ gatewayid: '', open: false })}
        centered
        width={400}
        bodyStyle={{
          padding: '30px',
          textAlign: 'center',
        }}
      >
        <Row justify='space-around'>
          <Col span={15}>
            <Input
              value={gateway.gatewayid || ''}
              onChange={(e) =>
                setGateway({ ...gateway, gatewayid: e.target.value })
              }
              placeholder='Enter Gateway link'
            />
          </Col>
          <Col span={9}>
            <Button type='primary' onClick={submitGatewayId}>
              Save
            </Button>
          </Col>
        </Row>
      </Modal>
    )
  }

  const columns = [
    {
      title: 'Device Name',
      dataIndex: 'device',
      className: 'column-width',
      sorter: (a, b) => a > b,
      // sorter: (a, b) => a.device?.name.localeCompare(b.device?.name),
      render: (record, obj) => renderDeviceName(record, obj),
    },
    {
      title: 'Shipping Address',
      dataIndex: 'device',
      width: '300px',
      render: (record, obj) => renderShippingAddress(record, obj),
    },
    {
      title: 'Device ID / Serials',
      dataIndex: 'device',
      className: 'column-width',
      render: (record, obj) =>
        obj.device_type === 'tracpatch'
          ? renderTracPatchFields(obj)
          : renderGatewayId(record, obj),
    },
    {
      title: 'Tracking Link',
      dataIndex: 'device',
      className: 'column-width',
      render: (record, obj) => renderTrackingLink(record, obj),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: 'column-width',
      render: (record, obj) => renderDeviceStatus(record, obj),
    },
    {
      title: 'Action',
      dataIndex: 'deviceid',
       width: '30px',
      render: (record, obj) => updateStatus(record, obj),      
    }
    // {
    //     title: 'Note',
    //     dataIndex: 'note',
    //     render: (record, obj) => renderNote(record, obj),
    // },
    // {
    //     title: 'Action',
    //     dataIndex: 'device',
    //     render: (record,obj) => renderMarkAsShipped(record,obj),
    // },
    // {
    //     title: 'ACTION',
    //     align: 'center',
    //     render: (row, obj) => <a onClick={(e) => handleResetClick(e, obj)}>Reset Password</a>
    // },
  ]

  // const rowSelection = {
  //   getCheckboxProps: (record) => ({
  //     disabled: record.status == 'Shipped',
  //     className: record.status == 'Shipped' ? 'shipped-checkbox' : '',
  //   }),
  //   selectedRowKeys: props.fullfillmentRequests?.key
  //     ? props.fullfillmentRequests.key
  //     : [],
  //   onChange: (key, row) =>
  //     props.onRowSelect({
  //       key,
  //       row: util.filterRows(row, key, props.fullfillmentRequests),
  //     }),
  // }
const rowSelection = {
  selectedRowKeys: props.fullfillmentRequests?.key ?? [],

  getCheckboxProps: (record) => {
    const isShipped = record.status === 'Shipped';
    const isActive = props.activeDevices?.some(
      (d) => d.deviceid === record.deviceid
    );

    return {
      disabled: isShipped, 
      className: isShipped ? 'shipped-checkbox' : '',
      isActive, // custom flag we'll use in onChange
    };
  },

  onChange: (keys, selectedRows) => {
    const validKeys = [];
    const validRows = [];

    selectedRows.forEach((row) => {
      const isActive = props.activeDevices?.some(
        (d) => d.deviceid == row.deviceid
      );
 
      if (!isActive) {
        message.warning(`Device ${row.device?.name || ''} is deleted`);
      } else {
        validKeys.push(row.key);
        validRows.push(row);
      }
    });

    props.onRowSelect({
      key: validKeys,
      row: util.filterRows(validRows, validKeys, props.fullfillmentRequests),
    });
  },
};

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table fullfillment-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={false}
        onChange={fetchFullfillments}
        bordered={false}
        rowSelection={rowSelection}
        rowClassName={(record) =>
          record.status == 'Shipped'
            ? 'row-shipped'
            : record.status == 'fail'
              ? 'row-failed'
              : ''
        }
        // onRow={handleRow}
      />
      {/* {renderNoteModal()}
            {renderTracklinLinkModal()}
            {renderGatewayIdModal()} */}
      {errorDetail && renderMetaDataModal()}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    users: state.user.users,
    user: state.profile.user,
    company: state.profile.company,
    sorter: state.user.sorter,
    searchText: state.user.searchText,
    pagination: state.user.pagination,
    active: state.user.active,
    isLoading: state.user.isLoading,
    fullfillments: state.device.fullfillments,
    fullfillmentDevices: state.device.fullfillmentDevices,
    fullfillmentRequests: state.message.fullfillmentRequests,
    activeDevices:state.patient.activeDevices,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onRowSelect: (rows) => dispatch(FullfillmentRowSelect(rows)),
    getFullfillmentViewDevices: (params) =>
      dispatch(getFullfillmentViewDevices(params)),
    updateTrackingLink: (params) => dispatch(updateTrackingLink(params)),
    updateGatewayId: (params) => dispatch(updateGatewayId(params)),
    markAsDeleted: (params) => dispatch(markAsDeleted(params)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullfillmentViewTable)
